import { IWords } from '../interfaces/iwords';

// Replace 'to' → first 'from'
export function replaceToWithFrom(
  text: string,
  replacements: IWords[]
): string {
  if (replacements.length === 0) {
    return text;
  }

  let result = text;
  for (const entry of replacements) {
    const regex = new RegExp(`(?<![\\p{L}\\p{N}])${escapeRegex(entry.to)}(?![\\p{L}\\p{N}])`, 'giu');
    result = result.replace(regex, entry.from[0]);
  }
  return result;
}

// Replace any 'from' → 'to'
export function replaceFromWithTo(
  text: string,
  replacements: IWords[]
): string {
  if (replacements.length === 0) {
    return text;
  }

  let result = text;
  for (const entry of replacements) {
    for (const fromWord of entry.from) {
      const regex = new RegExp(`(?<![\\p{L}\\p{N}])${escapeRegex(fromWord)}(?![\\p{L}\\p{N}])`, 'giu');
      result = result.replace(regex, entry.to);
    }
  }
  return result;
}

// Utility to escape RegExp special characters
function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function transformLabel(label: string): string {
  const lower = label.toLowerCase().replace(/_/g, ' ');
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

